import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

const StacksTableDescriptionCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={stack.description} />
    </TableSimpleCell>
  );
};

export default StacksTableDescriptionCell;
